// const generateAnalysisChartData = (reads = [],
//                                    previews = [],
//                                    comments = [],
//                                    likes = [],
//                                    shares =[]) => {
//   // Collect all unique dates from both reads and previews
//   const allDates = Array.from(
//     new Set([...reads.map((r) => r.date),
//         ...previews.map((p) => p.date),
//         ...comments.map((c) => c.date),
//         ...likes.map((l) => l.date),
//       ...shares.map((a) => a.date)]),
//   );
//
//   // Initialize arrays to hold the aligned counts
//   const alignedReads = [];
//   const alignedPreviews = [];
//   const alignedComments = [];
//   const alignedLikes = [];
//   const alignedShares = [];
//
//   // Populate aligned arrays
//   allDates.forEach((date) => {
//     const readItem = reads.find((r) => r.date === date);
//     const previewItem = previews.find((p) => p.date === date);
//     const commentItem = comments.find((c) => c.date === date);
//     const likeItem = likes.find((d) => d.date === date);
//     const shareItem = shares.find((s) => s.date === date);
//
//     alignedReads.push(readItem ? readItem.count : 0);
//     alignedPreviews.push(previewItem ? previewItem.count : 0);
//     alignedComments.push(commentItem ? commentItem.count : 0);
//     alignedLikes.push(likeItem ? likeItem.count : 0);
//     alignedShares.push(shareItem ? shareItem.count : 0);
//   });
//
//   return {
//     series: [
//       { name: "Reads", data: alignedReads },
//       { name: "Previews", data: alignedPreviews },
//       { name: "Comments", data: alignedComments },
//       { name: "Likes", data: alignedLikes },
//       { name: "Shares", data: alignedShares },
//     ],
//     chartOptions: {
//       chart: {
//         height: 500,
//         type: "bar", // Set the chart type to "bar"
//       },
//       dataLabels: {
//         enabled: false,
//       },
//       stroke: {
//         curve: "smooth",
//       },
//       plotOptions: {
//         bar: {
//           horizontal: false,
//           columnWidth: "80%",
//           endingShape: "rounded",
//         },
//       },
//       // xaxis: {
//       //   // type: "datetime",
//       //   type: "category",
//       //   categories: allDates,
//       // },
//         xaxis: {
//             type: "category",
//             categories: allDates,
//             tickPlacement: "on",
//             labels: {
//                 rotate: -45,
//                 style: {
//                     fontSize: "12px",
//                 },
//             },
//         },
//       tooltip: {
//         x: {
//           format: "MMMM dd, yyyy HH:mm", // More readable date format
//         },
//       },
//       yaxis: {
//         decimalsInFloat: 0, // Disable decimals on the y-axis
//       },
//       colors: ["#008FFB", "#00E396", "#1b2850", "#f72f00", "#6c8f98"],
//     },
//   };
// };
//
// export { generateAnalysisChartData };


const generateAnalysisChartData = (reads = [],
                                   previews = [],
                                   comments = [],
                                   likes = [],
                                   shares = []) => {
    // Collect all unique dates from both reads and previews (raw strings for matching)
    const allDates = Array.from(
        new Set([...reads.map((r) => r.date),
            ...previews.map((p) => p.date),
            ...comments.map((c) => c.date),
            ...likes.map((l) => l.date),
            ...shares.map((s) => s.date)]),
    );

    // Sort dates chronologically (assuming they are parseable strings)
    allDates.sort((a, b) => new Date(a) - new Date(b));

    // Format dates for display (date only, no time) - customize locale/format as needed
    const formattedDates = allDates.map(date =>
        new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
    );

    // Initialize arrays to hold the aligned counts
    const alignedReads = [];
    const alignedPreviews = [];
    const alignedComments = [];
    const alignedLikes = [];
    const alignedShares = [];

    // Populate aligned arrays (use raw dates for matching)
    allDates.forEach((date) => {
        const readItem = reads.find((r) => r.date === date);
        const previewItem = previews.find((p) => p.date === date);
        const commentItem = comments.find((c) => c.date === date);
        const likeItem = likes.find((l) => l.date === date);
        const shareItem = shares.find((s) => s.date === date);

        alignedReads.push(readItem ? readItem.count : 0);
        alignedPreviews.push(previewItem ? previewItem.count : 0);
        alignedComments.push(commentItem ? commentItem.count : 0);
        alignedLikes.push(likeItem ? likeItem.count : 0);
        alignedShares.push(shareItem ? shareItem.count : 0);
    });

    return {
        series: [
            { name: "Reads", data: alignedReads },
            { name: "Previews", data: alignedPreviews },
            { name: "Comments", data: alignedComments },
            { name: "Likes", data: alignedLikes },
            { name: "Shares", data: alignedShares },
        ],
        chartOptions: {
            chart: {
                height: 500,
                type: "bar", // Set the chart type to "bar"
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: "smooth",
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: "80%",
                    endingShape: "rounded",
                },
            },
            xaxis: {
                type: "category",
                categories: formattedDates,  // Use formatted dates (date only)
                tickPlacement: "on",
                labels: {
                    rotate: -45,
                    style: {
                        fontSize: "12px",
                    },
                },
            },
            tooltip: {
                x: {
                    // formatter: (value) => {
                    //     // Custom formatter for tooltip x-axis: show formatted date
                    //     return new Date(allDates[formattedDates.indexOf(value)]).toLocaleDateString('en-US', {
                    //         year: 'numeric',
                    //         month: 'long',
                    //         day: 'numeric'
                    //     });
                    // },
                    format: "MMMM dd, yyyy HH:mm"
                },
            },
            yaxis: {
                decimalsInFloat: 0, // Disable decimals on the y-axis
            },
            colors: ["#008FFB", "#00E396", "#1b2850", "#f72f00", "#6c8f98"],
        },
    };
};

export { generateAnalysisChartData };